import { getStore, type SchedulingDialogAnchor } from '../store/store';

export function getCalendarSchedulingAnchor(): SchedulingDialogAnchor | undefined {
    return getStore().anchor;
}
